import { FC } from 'react';
import { Box, CardMedia, Stack, Typography } from '@mui/material';
import type { InfoSlideQuestion } from '../../types';

interface InfoSlideWizardProps {
  question: InfoSlideQuestion;
}

/**
 * Renders the body of an InfoSlide — an image (optional) and rich text details
 * (optional). The slide has no interactive elements; it is read-only.
 * @param root0
 * @param root0.question
 */
export const InfoSlideWizard: FC<InfoSlideWizardProps> = ({ question }) => (
  <Stack spacing={3} alignItems="center">
    {question.imageUrl && (
      <CardMedia
        component="img"
        image={question.imageUrl}
        alt={question.title}
        sx={{ maxWidth: 400, maxHeight: 400, borderRadius: 1 }}
      />
    )}

    {question.details && (
      <Typography
        variant="body1"
        sx={{ textAlign: 'center', whiteSpace: 'pre-line', maxWidth: 600 }}
      >
        {question.details}
      </Typography>
    )}
  </Stack>
);
